import React from "react";

import BottombarView from './bottombar.view.component';
import BottombarMain from './bottombar.main.component';
import BottombarColor from './bottombar.color.component';
//import BottombarSeat from './bottombar.seat.component';
import BottombarScenario from './bottombar.scenario.component';
//import BottombarOptions from './bottombar.options.component';
import arrowBtn from '../../../assets/svgs/avatr/chevron-left.svg'

interface Props {
  car: any;
  color: any;
  seat: string;
  scenario: any;
  bottomMenu: string;
  isInternalView: boolean;
  showOtherMenus: boolean;
  enableAnimations: boolean;
  setColor: (value: any) => void;
  setSeat: (value: string) => void;
  setScenario: (value: any) => void;
  setInternalView: (value: boolean) => void;
  setShowScreenshotMenu: (value: boolean) => void;
  setShowGaleryMenu: (value: boolean) => void;
  setBottomMenu: (value: string) => void;

  bullet: any,
  showBulletMenu: boolean;
  setBullet: (value: any) => void;
  setShowBulletMenu: (value: boolean) => void;
}

const Bottombar: React.FC<Props> = ({ car, color, seat, scenario, isInternalView, showOtherMenus, bottomMenu, bullet, showBulletMenu, enableAnimations, setBullet, setColor, setSeat, setScenario, setInternalView, setBottomMenu, setShowBulletMenu}) => {

  const [resetColor, setResetColor] = React.useState(true);
  const [resetScenario, seScenarioColor] = React.useState(true);
  const [isCollapsed, setIsCollapsed] = React.useState(false);

  React.useEffect(() => {
    if(!car)
      return;
    setResetColor(true);
    seScenarioColor(true);
  }, [car, setResetColor, seScenarioColor]);

  return (
    <div className={`bottombar-full-container ${isCollapsed ? 'hidden':''} ${isCollapsed && bottomMenu === 'Seat' ? 'hiddenhigh':''}`}>
      <div className={`bottombar-collapse-btn ${isCollapsed ? 'collapsed':''}`} onClick={() => {setIsCollapsed(!isCollapsed)}}>
        <img src={arrowBtn} alt=''/>
      </div>

      <div className={`bottombar-menu-title`}>{car.name}</div>
      <div className={`bottombar-menu-container`}>
        {bottomMenu === 'Main' && <BottombarView enableAnimations={enableAnimations} title={car.name} subtitle={car.category} isInternalView={isInternalView} setInternalView={setInternalView}/>}
        {bottomMenu === 'Color' && <BottombarColor car={car} color={color} reset={resetColor} setReset={setResetColor} setColor={setColor}/>}
        {bottomMenu === 'Scenario' && <BottombarScenario car={car} scenario={scenario} reset={resetScenario} setReset={seScenarioColor} setScenario={setScenario}/>}
        {bottomMenu === 'Options' && <div className="bottombar-menu-color"/>}
        {/* {bottomMenu === 'Seat' && <BottombarSeat enableAnimations={enableAnimations} car={car} seat={seat} setSeat={setSeat}/>} */}
        {/* {bottomMenu === 'Options' && <BottombarOptions car={car} setMenu={setBottomMenu}/>} */}
      </div>
      <BottombarMain car={car} isInternalView={isInternalView} menu={bottomMenu} setMenu={setBottomMenu}/>
    </div>
  );
};

export default Bottombar;
